var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecondPlace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000003756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000003755"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.06893 21.5065C7.34715 21.5065 6.76204 20.9214 6.76204 20.1996V17.5859L8.06893 18.3327V21.5065Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17136 22.3845C8.89619 22.2469 8.72237 21.9656 8.72237 21.658V18.7061L10.7644 19.8729L12.1482 20.6637L13.2917 20.0102L15.7125 18.6269V21.715C15.7125 21.9922 15.5711 22.2503 15.3375 22.3995L13.0313 23.8723C12.7905 24.0261 12.4865 24.0421 12.2309 23.9143L9.17136 22.3845Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2275 21.5065C16.8617 21.5065 17.3758 20.9924 17.3758 20.3583V17.6765L16.2275 18.3327V21.5065Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8185 4.51332C3.31236 4.80254 3 5.3408 3 5.92374V15.4361L6.76204 17.5859L8.06893 18.3327L8.72237 18.7061L10.7644 19.8729L12.1482 20.6637L20.4779 15.9038C20.9841 15.6146 21.2964 15.0764 21.2964 14.4934V5.92374C21.2964 5.3408 20.9841 4.80254 20.4779 4.51332L12.9542 0.214033C12.4548 -0.0713441 11.8417 -0.0713447 11.3423 0.214033L3.8185 4.51332Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06893 21.5065C7.34715 21.5065 6.76204 20.9214 6.76204 20.1996V17.5859L8.06893 18.3327V21.5065Z",
    fill: "#B3ACA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17136 22.3845C8.89619 22.2469 8.72237 21.9656 8.72237 21.658V18.7061L10.7644 19.8729L11.3423 20.2032C11.8417 20.4885 12.4548 20.4885 12.9542 20.2032L13.2917 20.0102L15.7125 18.6269V21.715C15.7125 21.9922 15.5711 22.2503 15.3375 22.3995L13.0313 23.8723C12.7905 24.0261 12.4865 24.0421 12.2309 23.9143L9.17136 22.3845Z",
    fill: "#B3ACA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2275 21.5065C16.8617 21.5065 17.3758 20.9924 17.3758 20.3583V17.6765L16.2275 18.3327V21.5065Z",
    fill: "#B3ACA6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000003754"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 33",
    d: "M5.61377 12.9969V7.42031C5.61377 6.71778 5.98237 6.06677 6.58478 5.70532L11.1192 2.98466C11.7526 2.60464 12.5438 2.60464 13.1772 2.98466L17.7116 5.70532C18.314 6.06677 18.6826 6.71778 18.6826 7.42031V12.9969C18.6826 13.6994 18.314 14.3504 17.7116 14.7119L13.1772 17.4325C12.5438 17.8125 11.7526 17.8125 11.1192 17.4325L6.58478 14.7119C5.98237 14.3504 5.61377 13.6994 5.61377 12.9969Z",
    fill: "url(#paint0_linear_4613_18163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M10.7911 12.5069V11.8627L12.4617 10.1871C12.6214 10.0221 12.7546 9.87544 12.8611 9.74724C12.9676 9.61903 13.0475 9.49483 13.1007 9.37464C13.154 9.25444 13.1806 9.12623 13.1806 8.99001C13.1806 8.83456 13.1462 8.70155 13.0773 8.59097C13.0083 8.47879 12.9136 8.39225 12.793 8.33135C12.6723 8.27045 12.5353 8.24 12.3818 8.24C12.2236 8.24 12.085 8.27366 11.9659 8.34097C11.8469 8.40667 11.7545 8.50042 11.6887 8.62222C11.6244 8.74402 11.5923 8.88905 11.5923 9.05732H10.7629C10.7629 8.74482 10.8326 8.47318 10.9721 8.24241C11.1115 8.01163 11.3033 7.83294 11.5477 7.70634C11.7936 7.57974 12.0756 7.51643 12.3935 7.51643C12.7162 7.51643 12.9997 7.57813 13.2441 7.70153C13.4884 7.82493 13.678 7.99401 13.8127 8.20875C13.9489 8.4235 14.0171 8.6687 14.0171 8.94434C14.0171 9.12864 13.9826 9.30973 13.9137 9.48762C13.8448 9.66551 13.7234 9.86262 13.5495 10.079C13.3772 10.2953 13.1352 10.5573 12.8235 10.865L11.9941 11.728V11.7617H14.0899V12.5069H10.7911Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4613_18163",
    x1: 17.6391,
    y1: 4.87721,
    x2: 7.39166,
    y2: 15.1246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAD1CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#706B63"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondPlace);
export default __webpack_public_path__ + "static/media/second-place.d1ff53b12d32a2104086aa66e83f7d07.svg";
export { ForwardRef as ReactComponent };